<div class="modal-doc">
    <app-spinner
        [show]="flagLoading"
        [text]="'Subiendo archivo... ' + value + '%'"
        [type]="'absolute'"
        [size]="'medium'"
        [color]="'#B1476A'"
        [trackColor]="'#4CA7C8'"
        [blurBackground]="true"
    ></app-spinner>

    <div class="modal-doc__head">
        <span class="material-icons">upload_file</span>
        <h3>{{ data.label }}</h3>
    </div>

    <div class="modal-doc__body">
        <div class="ds-alert ds-alert--info">
            <span class="material-icons">info</span>
            <div>Se recomienda tomar la fotografía fuera del navegador y luego adjuntarla.</div>
        </div>

        <label class="ds-dropzone">
            <span class="material-icons">cloud_upload</span>
            <span><strong>Seleccionar archivo</strong></span>
            <span>PDF, JPG, PNG o HEIC · hasta {{ maxArchivoMb }} MB</span>
            <input #fileInput type="file" [accept]="data.accept" (change)="onFileSelected($event)" />
        </label>

        <div class="modal-doc__preview" *ngIf="previewUrl && !flagLoading">
            <img *ngIf="selectedFile?.type?.startsWith('image/')" [src]="previewUrl" alt="Vista previa" />
            <div class="modal-doc__file">
                <span class="material-icons">description</span>
                <span class="modal-doc__file-name">{{ selectedFile?.name }}</span>
                <button type="button" class="modal-doc__del" (click)="clearSelectedFile()"
                    aria-label="Eliminar archivo">
                    <span class="material-icons">delete</span>
                </button>
            </div>
        </div>
    </div>

    <div class="modal-doc__actions">
        <button type="button" class="ds-pill ds-pill--ghost" (click)="closeModal()">Cancelar</button>
        <button type="button" class="ds-pill ds-pill--primary" [disabled]="flagDisableButton" (click)="aceptar()">
            <span class="material-icons">check_circle</span>
            Aceptar
        </button>
    </div>
</div>
